export default __webpack_public_path__ + "static/media/wf_impact_isf_articles_us-mayors-climate-change_desktop.7e91d312.jpg";